import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Pagination } from "react-bootstrap";
import { scrollToTop } from "../../../shared/functions/ScrollToTop";
import ImageBlurHash from "../../../shared/components/imageBlurHash";
import { useLocation, useNavigate } from "react-router-dom";

const ProjectsCards = () => {
  const projects = [
    {
      id: 0,
      project: "Project1",
      projectDesc: "Project1Desc",
      projectDate: "11/14/2005",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 1,
      project: "Project2",
      projectDesc: "Project2Desc",
      projectDate: "6/30/2012",
      client: "RiyadhRegionMunicipality",
      clientLogo: "/media/assets/clients/RiyadhRegionMunicipality.png",
    },
    {
      id: 2,
      project: "Project3",
      projectDesc: "Project3Desc",
      projectDate: "10/22/2011",
      client: "MunicipalRuralAffairs",
      clientLogo: "/media/assets/clients/MOMRAH.png",
    },
    {
      id: 3,
      project: "Project39",
      projectDesc: "Project39Desc",
      projectDate: "2015",
      client: "Tahakom",
      clientLogo: "/media/assets/clients/Tahakom.png",
    },
    {
      id: 4,
      project: "Project15",
      projectDesc: "Project15Desc",
      projectDate: "9/7/2022",
      client: "Aldarah",
      clientLogo: "/media/assets/clients/Aldarah.svg",
    },
    {
      id: 5,
      project: "Project6",
      projectDesc: "Project6Desc",
      projectDate: "10/24/2021",
      client: "TransportGeneralAuthority",
      clientLogo: "/media/assets/clients/TGA.png",
    },
    {
      id: 6,
      project: "Project7",
      projectDesc: "Project7Desc",
      projectDate: "7/14/2023",
      client: "NCVC",
      clientLogo: "/media/assets/clients/NCNV2.png",
    },
    {
      id: 7,
      project: "Project31",
      projectDesc: "Project31Desc",
      projectDate: "10/17/2022",
      client: "Davita",
      clientLogo: "/media/assets/clients/Davita.png",
    },
    {
      id: 8,
      project: "Project9",
      projectDesc: "Project9Desc",
      projectDate: "2/1/2006",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 9,
      project: "Project10",
      projectDesc: "Project10Desc",
      projectDate: "5/7/2008",
      client: "RiyadhRegionMunicipality",
      clientLogo: "/media/assets/clients/RiyadhRegionMunicipality.png",
    },
    {
      id: 10,
      project: "Project11",
      projectDesc: "Project11Desc",
      projectDate: "5/14/2022",
      client: "TransportGeneralAuthority",
      clientLogo: "/media/assets/clients/TGA.png",
    },
    {
      id: 11,
      project: "Project12",
      projectDesc: "Project12Desc",
      projectDate: "6/18/2007",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 12,
      project: "Project13",
      projectDesc: "Project13Desc",
      projectDate: "7/29/2008",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 13,
      project: "Project14",
      projectDesc: "Project14Desc",
      projectDate: "7/28/2011",
      client: "TransportGeneralAuthority",
      clientLogo: "/media/assets/clients/RiyadhRegionMunicipality.png",
    },
    {
      id: 14,
      project: "Project5",
      projectDesc: "Project5Desc",
      projectDate: "1/11/2007",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 15,
      project: "Project16",
      projectDesc: "Project16Desc",
      projectDate: "3/26/2008",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 16,
      project: "Project17",
      projectDesc: "Project17Desc",
      projectDate: "3/24/2009",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 17,
      project: "Project18",
      projectDesc: "Project18Desc",
      projectDate: "6/30/2009",
      client: "RiyadhRegionMunicipality",
      clientLogo: "/media/assets/clients/RiyadhRegionMunicipality.png",
    },
    {
      id: 18,
      project: "Project19",
      projectDesc: "Project19Desc",
      projectDate: "11/17/2022",
      client: "TransportGeneralAuthority",
      clientLogo: "/media/assets/clients/TGA.png",
    },
    {
      id: 19,
      project: "Project20",
      projectDesc: "Project20Desc",
      projectDate: "4/14/2010",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    // {
    //   id: 20,
    //   project: "Project21",
    //   projectDesc: "Project21Desc",
    //   projectDate: "3/24/2009",
    //   client: "SaudiTelecom",
    //   clientLogo: "/media/assets/clients/stc.png",
    // },
    {
      id: 21,
      project: "Project22",
      projectDesc: "Project22Desc",
      projectDate: "11/11/2022",
      client: "TransportGeneralAuthority",
      clientLogo: "/media/assets/clients/TGA.png",
    },
    {
      id: 22,
      project: "Project23",
      projectDesc: "Project23Desc",
      projectDate: "5/21/2011",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
  
    {
      id: 24,
      project: "Project25",
      projectDesc: "Project25Desc",
      projectDate: "8/7/2011",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 25,
      project: "Project26",
      projectDesc: "Project26Desc",
      projectDate: "5/6/2012",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 26,
      project: "Project27",
      projectDesc: "Project27Desc",
      projectDate: "6/24/2014",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 27,
      project: "Project28",
      projectDesc: "Project28Desc",
      projectDate: "2015",
      client: "Tahakom",
      clientLogo: "/media/assets/clients/Tahakom.png",
    },
    {
      id: 28,
      project: "Project29",
      projectDesc: "Project29Desc",
      projectDate: "7/22/2014",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 29,
      project: "Project30",
      projectDesc: "Project30Desc",
      projectDate: "11/12/2014",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 30,
      project: "Project8",
      projectDesc: "Project8Desc",
      projectDate: "5/18/2006",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 31,
      project: "Project32",
      projectDesc: "Project32Desc",
      projectDate: "3/30/2017",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 32,
      project: "Project33",
      projectDesc: "Project33Desc",
      projectDate: "8/3/2016",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 33,
      project: "Project34",
      projectDesc: "Project34Desc",
      projectDate: "2007",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 34,
      project: "Project35",
      projectDesc: "Project35Desc",
      projectDate: "2016",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 35,
      project: "Project36",
      projectDesc: "Project36Desc",
      projectDate: "2017",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 36,
      project: "Project37",
      projectDesc: "Project37Desc",
      projectDate: "2010",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
      {
      id: 23,
      project: "Project24",
      projectDesc: "Project24Desc",
      projectDate: "2015",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
    {
      id: 37,
      project: "Project38",
      projectDesc: "Project38Desc",
      projectDate: "4/19/2006",
      client: "SaudiTelecom",
      clientLogo: "/media/assets/clients/stc.png",
    },
  ];
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const initialPage = parseInt(searchParams.get("page") || "1", 10);
  const [currentPage, setCurrentPage] = useState(initialPage);
  const itemsPerPage = 8;

  const totalPages = Math.ceil(projects.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = projects.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber:number) => {
    setCurrentPage(pageNumber);
    navigate(`?page=${pageNumber}`);
  };

  useEffect(() => {
    const newPage = parseInt(searchParams.get("page") || "1", 10);
    setCurrentPage(newPage);
  }, [location.search]);
  return (
    <div className="container">
      <div className="projects-header">
        <h3>{intl.formatMessage({ id: "Projects" })}</h3>
        <p>{intl.formatMessage({ id: "ProjectsDesc" })}</p>
      </div>
      <div className="projects-cards">
        {currentItems.map((project) => (
          <div key={project.id} className="project-card">
            <h4>{intl.formatMessage({ id: project.project })}</h4>
            <div className="project-Desc">
              {intl.formatMessage({ id: project.projectDesc })}
            </div>

            <div className="project-date">
              <ImageBlurHash
                hash="L8H{Zs?ZCR560T~U9E9~t94n#UD*"
                height={200}
                src="/media/assets/icons/calendar.svg"
                alt="calendar"
                classes=""
              />
              <span>{project.projectDate}</span>
            </div>
            <div className="project-client">
              <ImageBlurHash
                hash="L8H{Zs?ZCR560T~U9E9~t94n#UD*"
                height={200}
                src={project.clientLogo}
                alt="client-logo"
                classes=""
              />
              <p>{intl.formatMessage({ id: project.client })}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mb-5 d-flex justify-content-center">
        <Pagination>
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            linkClassName="custom-pagination-button"
          />
          {Array.from({ length: totalPages }).map((_, index) => (
            <Pagination.Item
              key={index}
              active={index + 1 === currentPage}
              onClick={() => {
                handlePageChange(index + 1);
                scrollToTop();
              }}
              linkClassName={`custom-pagination-button ${
                index + 1 === currentPage
                  ? "active-page background-linear-gradient-color"
                  : ""
              }`}
            >
              {index + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            linkClassName="custom-pagination-button"
          />
        </Pagination>
      </div>
    </div>
  );
};

export default ProjectsCards;